import React from 'react'

const DiamondIcon = ({ className, size = 24, color = 'currentColor' }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="diamond-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(100, 200, 255, 1)" />
          <stop offset="50%" stopColor="rgba(200, 100, 255, 1)" />
          <stop offset="100%" stopColor="rgba(255, 100, 200, 1)" />
        </linearGradient>
        <filter id="diamond-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      <path 
        d="M6 3L2 9L12 21L22 9L18 3H6Z" 
        stroke="url(#diamond-gradient)" 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        filter="url(#diamond-glow)"
      />
      <path 
        d="M2 9H22M6 3L12 21M18 3L12 21M9 3L12 9L15 3" 
        stroke="url(#diamond-gradient)" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        opacity="0.6"
      />
      <circle cx="12" cy="7" r="1" fill="url(#diamond-gradient)" opacity="0.8" />
    </svg>
  )
}

export default DiamondIcon
